export default __webpack_public_path__ + "static/la-playa-vol-3-homepage-anner-mobile-w2-bde79c7e13d5865ad66297fa52f3b149.webp";